import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import BusinessContent from './components/BusinessContent';
import ServicesOverview from './components/ServicesOverview';
import ServiceSection from './components/ServiceSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import { useJsonLd } from '../../hooks/useJsonLd';

const serviceData = [
  {
    id: 'produce',
    number: '01 — プロデュース',
    title: 'プロデュース',
    subtitle: '物件の可能性を最大限に引き出すコンセプト設計',
    description:
      '物件の立地・特性を徹底的に分析し、ターゲット層に刺さる独自のコンセプトを設計します。内装デザインの方向性から集客プラットフォームの選定、料金設定まで、成功する貸別荘・民泊を一緒に作り上げます。',
    points: [
      'ターゲット分析・コンセプト立案',
      '内装デザイン・備品選定のアドバイス',
      'OTA（宿泊予約サイト）掲載・最適化',
      '価格戦略・収益シミュレーション',
      '開業前チェックリスト提供',
    ],
    imageUrl:
      'https://public.readdy.ai/ai/img_res/162f48b1bb6448ecf59b26fdd6deca50.jpg',
    reverse: false,
    bgLight: false,
  },
  {
    id: 'minpaku',
    number: '02 — 民泊申請代行',
    title: '民泊申請代行',
    subtitle: '民泊新法（住宅宿泊事業法）に基づく届出を全面代行',
    description:
      '複雑な法令に対応した民泊届出の書類作成から行政への提出まで、すべての手続きを専門スタッフが代行いたします。申請にかかる時間と手間を大幅に削減し、スムーズな開業をサポートします。',
    points: [
      '民泊新法に基づく届出書類作成',
      '消防・衛生基準への適合確認',
      '管轄窓口への書類提出・進捗管理',
      '近隣への説明・対応サポート',
      '届出完了後のフォローアップ',
    ],
    imageUrl:
      'https://readdy.ai/api/search-image?query=Professional%20Japanese%20business%20official%20documents%20application%20paperwork%20clean%20minimal%20white%20office%20desk%20natural%20sunlight%20warm%20tones%20permit%20approval%20consultation%20neat%20organized%20workspace&width=800&height=600&seq=minpaku-section-001&orientation=landscape',
    reverse: true,
    bgLight: true,
  },
  {
    id: 'kantan',
    number: '03 — 簡易宿所申請代行',
    title: '簡易宿所申請代行',
    subtitle: '旅館業法に基づく簡易宿所営業許可申請を代行',
    description:
      '旅館業法の「簡易宿所」として営業許可を取得する複雑な申請手続きを、経験豊富な専門スタッフが全面的に代行します。保健所・消防署・建築確認など多岐にわたる関係機関への対応も一括サポートします。',
    points: [
      '旅館業法に基づく許可申請書類作成',
      '保健所・消防署との事前協議',
      '建築確認・用途変更対応',
      '施設基準適合のアドバイス',
      '許可取得まで一貫サポート',
    ],
    imageUrl:
      'https://readdy.ai/api/search-image?query=Official%20Japanese%20building%20permit%20architectural%20blueprints%20legal%20documentation%20approval%20process%20government%20office%20consultation%20clean%20desk%20organized%20professional%20warm%20lighting%20modern%20office%20environment&width=800&height=600&seq=kantan-section-001&orientation=landscape',
    reverse: false,
    bgLight: false,
  },
  {
    id: 'kanri',
    number: '04 — 民泊貸別荘の管理業務',
    title: '民泊貸別荘の管理業務',
    subtitle: 'オーナー様に代わって物件を丁寧に管理します',
    description:
      '予約管理からゲスト対応、清掃・点検、緊急時の対応まで、物件運営に必要なすべての管理業務を代行いたします。オーナー様はわずらわしい日常業務から解放され、収益だけに集中できます。',
    points: [
      '宿泊予約管理・チェックイン/アウト対応',
      '多言語ゲストサポート（日本語・英語）',
      '清掃・リネン交換・備品補充',
      '定期的な施設点検・メンテナンス',
      '収支レポートの定期提出',
    ],
    imageUrl:
      'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20vacation%20rental%20cottage%20exterior%20garden%20property%20management%20professional%20service%20team%20warm%20daylight%20lush%20green%20trees%20serene%20peaceful%20mountain%20landscape%20maintained%20grounds&width=800&height=600&seq=kanri-section-001&orientation=landscape',
    reverse: true,
    bgLight: true,
  },
  {
    id: 'reform',
    number: '05 — 建物リフォーム事業',
    title: '建物リフォーム事業',
    subtitle: '集客力を高めるリノベーションで物件価値を向上',
    description:
      '古い物件でも、戦略的なリノベーションで高稼働率を実現できます。貸別荘・民泊に特化したデザインリフォームで、ゲストが「また泊まりたい」と感じる特別な空間を創り出します。',
    points: [
      '宿泊施設に特化したインテリアデザイン',
      '水回り（浴室・洗面・キッチン）リフォーム',
      '外壁・屋根・断熱工事',
      'バリアフリー対応工事',
      'DIY体験・古民家再生プロジェクト',
    ],
    imageUrl:
      'https://readdy.ai/api/search-image?query=Modern%20Japanese%20interior%20renovation%20craftsmen%20at%20work%20fresh%20natural%20wood%20materials%20bright%20clean%20elegant%20transformation%20natural%20light%20airy%20space%20premium%20building%20renovation%20warm%20tones%20beautiful%20result&width=800&height=600&seq=reform-section-001&orientation=landscape',
    reverse: false,
    bgLight: false,
  },
  {
    id: 'kashisouvilla',
    number: '06 — 貸別荘の運営',
    title: '貸別荘の運営',
    subtitle: '特別な滞在体験を生み出す、魅力ある貸別荘を運営',
    description:
      '私たちは豊かな自然環境や地域の魅力を活かした貸別荘の企画・運営を手がけています。ゲストが「また来たい」と感じる特別な体験空間をつくり、高稼働率と長期的な収益安定を実現します。',
    points: [
      'コンセプト設計・インテリアコーディネート',
      '各種予約プラットフォームへの掲載・管理',
      '多言語対応のゲストサポート',
      '清掃・備品補充・施設メンテナンス',
      '収益レポートの定期提出とオーナー報告',
    ],
    imageUrl:
      'https://readdy.ai/api/search-image?query=Stunning%20luxury%20wooden%20vacation%20rental%20villa%20in%20Japanese%20forest%20mountain%20landscape%20large%20windows%20overlooking%20nature%20pool%20deck%20exterior%20twilight%20golden%20sunset%20warm%20amber%20glow%20trees%20premium%20resort%20atmosphere%20serene&width=800&height=600&seq=kashisouvilla-section-001&orientation=landscape',
    reverse: true,
    bgLight: true,
  },
];

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

  useJsonLd({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        '@id': `${siteUrl}/#website`,
        url: `${siteUrl}/`,
        name: '株式会社グランドビレッジ',
        description: '貸別荘の運営・民泊申請代行・簡易宿所申請代行・物件管理業務・建物リフォームまでトータルサポート',
        inLanguage: 'ja',
      },
      {
        '@type': 'WebPage',
        '@id': `${siteUrl}/#webpage`,
        url: `${siteUrl}/`,
        name: '株式会社グランドビレッジ｜貸別荘の運営・民泊申請代行・管理・リフォーム',
        isPartOf: { '@id': `${siteUrl}/#website` },
        about: { '@id': `${siteUrl}/#organization` },
        description: '貸別荘の運営・民泊申請代行・簡易宿所申請代行・物件管理業務・建物リフォームまでトータルサポートする株式会社グランドビレッジ公式サイト',
        inLanguage: 'ja',
        dateModified: '2026-03-25',
      },
      {
        '@type': ['Organization', 'LocalBusiness'],
        '@id': `${siteUrl}/#organization`,
        name: '株式会社グランドビレッジ',
        alternateName: 'Grand Village Co., Ltd.',
        url: `${siteUrl}/`,
        email: 'globalvillage4548tvc@gmail.com',
        description: '貸別荘の運営・民泊申請代行・簡易宿所申請代行・物件管理業務・建物リフォームまでトータルサポートする株式会社グランドビレッジ。',
        founder: { '@type': 'Person', name: '太田嶋 信二' },
        address: [
          {
            '@type': 'PostalAddress',
            streetAddress: '下馬5-41-15',
            addressLocality: '世田谷区',
            addressRegion: '東京都',
            addressCountry: 'JP',
          },
          {
            '@type': 'PostalAddress',
            postalCode: '413-0231',
            streetAddress: '富戸1317-2661',
            addressLocality: '伊東市',
            addressRegion: '静岡県',
            addressCountry: 'JP',
          },
        ],
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 34.8936,
          longitude: 139.1282,
        },
        areaServed: { '@type': 'Country', name: 'Japan' },
        serviceType: [
          '貸別荘の運営',
          '民泊申請代行',
          '簡易宿所申請代行',
          '民泊管理業務',
          '建物リフォーム',
        ],
        sameAs: ['https://nels-house.com/'],
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: 'グランドビレッジのサービス',
          itemListElement: [
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'プロデュース', description: '物件の可能性を最大限に引き出すコンセプト設計' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '民泊申請代行', description: '民泊新法（住宅宿泊事業法）に基づく届出を全面代行' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '簡易宿所申請代行', description: '旅館業法に基づく簡易宿所営業許可申請を代行' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '民泊貸別荘の管理業務', description: 'オーナー様に代わって物件を丁寧に管理' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '建物リフォーム事業', description: '集客力を高めるリノベーションで物件価値を向上' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '貸別荘の運営', description: '特別な滞在体験を生み出す、魅力ある貸別荘を運営' } },
          ],
        },
      },
    ],
  });

  return (
    <div className="relative font-sans" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
      <Navbar />
      <Hero />
      <BusinessContent />
      <ServicesOverview />
      {serviceData.map((s) => (
        <ServiceSection
          key={s.id}
          id={s.id}
          number={s.number}
          title={s.title}
          subtitle={s.subtitle}
          description={s.description}
          points={s.points}
          imageUrl={s.imageUrl}
          reverse={s.reverse}
          bgLight={s.bgLight}
        />
      ))}
      <ContactSection />
      <Footer />
    </div>
  );
}
